<script>
import Vue from "vue";
import Component from "vue-class-component";
@Component({
  // name: "multiline-table",
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    cloumns: {
      type: Array,
      default: () => []
    },
    records: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({
        pageSize: 10,
        pageNumber: 1,
        total: 0
      })
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    tableConfig: {
      type: Object,
      default: () => ({
        props: {},
        on: {}
      })
    }
  },
  methods: {
    handleCurrentChange(pageNumber) {
      if (pageNumber === this.pagination.pageNumber) return false;
      this.pagination.pageNumber = pageNumber;
      this.$emit("handleCurrentChange", this.pagination);
    },
    selectCheck (records) {
      records.forEach(item => {
        this.$refs.multipleTable.toggleRowSelection(item, true)
      })
    },
    handleSizeChange(pageSize) {
      if (pageSize === this.pagination.pageSize) return false;
      this.pagination.pageSize = pageSize;
      this.$emit("handleCurrentChange", this.pagination);
    }
  }
})
export default class multilineTable extends Vue {
  tableConfigOn = {
    "selection-change": this.selectionahange,
    "row-click": this.handleRowClick
  };
  selectList = [];
  selectItem = null;

  handleRowClick(row, event, column) {
    this.selectItem = row;
  }
  selectionahange(selection) {
    this.selectList = selection;
  }
  created() {
    if (typeof this.tableConfig.on["selection-change"] === "function") {
      this.tableConfigOn["selection-change"] = selection => {
        this.tableConfig.on["selection-change"](selection);
        this.selectionahange(selection);
      };
    }
    if (typeof this.tableConfig.on["row-click"] === "function") {
      this.tableConfigOn["row-click"] = (row, event, column) => {
        this.tableConfig.on["row-click"](row, event, column);
        this.handleRowClick(row, event, column);
      };
    }
    this.tableConfigOn = {
      ...this.tableConfig.on,
      ...this.tableConfigOn
    };
  }
  render(h) {
    const tableProps = {
      ...this.tableConfig.props,
      highlightCurrentRow:
        this.tableConfig.props.highlightCurrentRow === false ? false : true,
      border:
        (this.tableConfig.props && this.tableConfig.props.border) !== undefined
          ? this.tableConfig.props.border
          : true
    };
    return (
      <el-row style="padding: 10px;">
        <el-row style="margin-bottom: 10px;">
          <el-table
            ref="multipleTable"
            class="multilineTable__style"
            data={this.dataSource}
            {...{
              props: tableProps,
              on: {
                ...this.tableConfigOn
              }
            }}
          >
            {this.cloumns.map((item, $index) => {
              return renderColumn(item);
            })}
          </el-table>
        </el-row>
        {this.isPagination === true && (
          <el-row>
            <el-pagination
              {...{
                on: {
                  "current-change": this.handleCurrentChange,
                  "update:currentPage": page => {},
                  'size-change': this.handleSizeChange
                },
                props: {
                  layout: this.pagination.layout || "prev, pager, next, jumper, total",
                  currentPage: this.pagination.pageNumber,
                  pageSize: this.pagination.pageSize,
                  total: this.pagination.total,
                  pageSizes: this.pagination.pageSizes
                }
              }}
            ></el-pagination>
          </el-row>
        )}
      </el-row>
    );
    function renderColumn(item) {
      const props = {
        showOverflowTooltip: true,
        headerAlign: item.headerAlign ? item.headerAlign : "center",
        ...item
      };
      if (item.children && item.children.length > 0) {
        return (
          <el-table-column {...{ props: props }}>
            {item.children.map(renderColumn)}
          </el-table-column>
        );
      } else {
        if (!item.render) {
          return <el-table-column {...{ props: props }}></el-table-column>;
        } else {
          return (
            <el-table-column {...{ props: item }}>
              {({ row, $index }) => {
                return item.render(h, row[item.property], row, $index);
              }}
            </el-table-column>
          );
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .multilineTable__style {
      font-size: 12px;
    }
</style>